import $ from "jquery"
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { itemReportFields } from "../common/search-filter/search/itemreportfilters.jsx"
import { FiltersState } from "../state/listing/generic-listing/index.js"
import ItemReportModal from "./itemreportmodal.component.jsx"
const uuidv4 = require("uuid/v4")

interface OwnProps {
    data: {
        productId: string,
        productTitle: string,
        productSku: string,
    }
    filters: FiltersState
}

const ItemReportOrdersButton = (props: OwnProps) => {

    const modalUniqueId = props.data.productId ? `reportModal-${props.data.productId}` : `reportModal-${uuidv4()}`
    
    const [showModal, setShowModal] = useState(false)

    const handleOpenModal = () => {
        $(`#${modalUniqueId}`).modal("show")
        setShowModal(true)
    }

    const handleCloseModal = () => {
        $(`#${modalUniqueId}`).modal("hide")
        setShowModal(false)
    }

    return (
        <>
            <div className='modal item-report-modal-xl' id={modalUniqueId} role="dialog" 
                data-backdrop="static" data-keyboard="false" aria-hidden="true" >
                <div className="modal-dialog modal-xl" role="document">
                    { showModal && <ItemReportModal
                        filters={props.filters.filters}
                        productId={props.data.productId}
                        fields={itemReportFields}
                        searchKeywords={props.filters.keywords}
                        productTitle={props.data.productTitle}
                        productSku={props.data.productSku}
                        onClose={handleCloseModal}
                    /> }
                </div>
            </div>

            <button type="button" className={"btn btn-outline-primary"} onClick={handleOpenModal}>
                <FormattedMessage
                    id="orders.item_report_orders_button.button_label"
                    defaultMessage="Orders"
                />
            </button>
        
        </>
    )
}

export default ItemReportOrdersButton


// WEBPACK FOOTER //
// ./src/order/ItemReportOrdersButton.tsx